import * as types from "../actions/actionTypes";
import mergeDeep from "../utils/global";
import { I18n } from "react-i18nify";

const initialState = {
  filters: {},
  specificLetterChannelFilter: []
};

const updateInputFilter = (newState, filterKey, value, view) => {
  newState.filters[view][filterKey].value = value;
  return newState;
};

const updateCheckboxFilter = (newState, filterKey, value, label, view) => {
  newState.filters[view][label].value[filterKey] = value;
  return newState;
};

const updateDateFilter = (newState, filterKey, value, label, view) => {
  newState.filters[view][filterKey].value[label] = value.valueOf();
  return newState;
};

const updateSelectFilter = (newState, filterKey, value, view) => {
  Object.keys(newState.filters[view][filterKey].value).forEach(val => {
    newState.filters[view][filterKey].value[val].actif = false;
  });
  newState.filters[view][filterKey].value[value].actif = true;
  return newState;
};

const filtersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INIT_FILTERS: {
      let newState = {};
      mergeDeep(newState, state);
      newState.filters[action.view] = action.filters[action.view];

      if (action.view === "letters" && state.specificLetterChannelFilter && state.specificLetterChannelFilter.length) {
        let channelFilterValue = {
          ALL: { actif: true, label: "Tous" }
        }
        for (let i = 0; i < state.specificLetterChannelFilter.length; i++) {
          channelFilterValue[state.specificLetterChannelFilter[i]] = {actif:false,label:state.specificLetterChannelFilter[i]}
        }
        const channelFilter = {
          type:"select",
          label: I18n.t("letterList.channel"),
          value: channelFilterValue
        };
        newState.filters[action.view].channel = channelFilter;
      }

      return newState;
    }
    case types.UPDATE_FILTERS: {
      let newState = {};
      mergeDeep(newState, state);
      if (action.filterType === "input") {
        newState = updateInputFilter(
          newState,
          action.filterKey,
          action.value,
          action.view
        );
      } else if (action.filterType === "checkbox") {
        newState = updateCheckboxFilter(
          newState,
          action.filterKey,
          action.value,
          action.label,
          action.view
        );
      } else if (action.filterType === "select") {
        newState = updateSelectFilter(
          newState,
          action.filterKey,
          action.value,
          action.view
        );
      } else if (action.filterType === "date") {
        newState = updateDateFilter(
          newState,
          action.filterKey,
          action.value,
          action.label,
          action.view
        );
      }
      return newState;
    }
    case types.REQUEST_LETTERS_SUCCESS: {
      let letterChannelFilter = [];
      for (let i = 0; i < action.letters.length; i++) {
        if (letterChannelFilter.indexOf(action.letters[i].channel) < 0) {
          letterChannelFilter.push(action.letters[i].channel);
        }
      }
      return { ...state, specificLetterChannelFilter: letterChannelFilter};
    }
    case types.APP_FLUSH_DATAS:
      return { filters: {} };
    default:
      return state;
  }
};

export default filtersReducer;



// WEBPACK FOOTER //
// ./src/reducers/filtersReducer.js